import React, { Component } from "react";
import "./style.css";
import "../../../../index.css";
class MajorIntroItem extends Component {
  render() {
    const { title, color, content } = this.props;
    return (
      <div className="majorIntroItem_box">
        <div className="majorIntroItem_box_top">
          <div
            style={{ backgroundColor: color }}
            className="majorIntroItem_box_top_square fl"
          ></div>
          <div className="majorIntroItem_box_top_title fl">{title}</div>
          <div className="clear"></div>
        </div>
        <div
          className="majorIntroItem_box_content"
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
      </div>
    );
  }
}

export default MajorIntroItem;



// WEBPACK FOOTER //
// ./src/containers/MajorIntro/components/MajorIntroItem/index.js